import { render, staticRenderFns } from "./OcePlay.vue?vue&type=template&id=8cd475b6&"
import script from "./OcePlay.vue?vue&type=script&lang=js&"
export * from "./OcePlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports